var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50%",
    height: "50%",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".saml_svg__cls-1{fill:#eb4335}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "saml_svg__cls-1",
    d: "M482.02,427.95c-136.39,49.68-276.01,74.72-421.45,60.82,22.41-1.39,44.84-2.48,67.22-4.24,22.44-1.77,44.9-3.62,67.22-6.45,46.96-5.95,93.46-14.2,136.06-36.37,27.27-14.19,51.47-33.1,53.93-65.82,1.41-18.81-1.36-40.81-10.29-56.91-17.16-30.92-39.99-58.69-60.62-87.66-2.81-3.95-6.48-7.29-11.21-12.52,50.03,28.3,154.58,150.56,179.13,209.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "saml_svg__cls-1",
    d: "M152,261.56c17.18-89.43,42.4-174.96,91.59-254.14,108.64,91.5,197.51,195.58,256.41,323.58-15.29-22.61-29.25-46.28-46.17-67.59-28.64-36.07-58.82-70.95-89.13-105.66-7.45-8.53-17.54-14.99-27.03-21.49-57.11-39.1-106.47-29.5-141.52,30.39-17.3,29.57-29.2,62.3-44.15,94.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "saml_svg__cls-1",
    d: "M263.31,375.4C179.3,407.36,93.58,428.3,.28,424.73,25.08,283.09,71.84,152.49,154.31,35.79c-14.43,29.93-29.36,59.63-43.18,89.84-21.05,46.03-39.75,92.98-46.05,143.72-1.61,13-2.32,26.45-.92,39.43,4.72,44.01,32.54,70.73,77.01,77.05,37.75,5.36,74.36-1.11,111.01-8.53,3.69-.75,7.42-1.28,11.13-1.91Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaml);
export default __webpack_public_path__ + "static/media/saml.36306a91d966236866a45a6f5c5a86a8.svg";
export { ForwardRef as ReactComponent };